import React, { Component } from 'react';
import {
  Button, Form, Modal, Spinner, Table,
} from 'react-bootstrap';
import { searchPlayJson } from './searchPlayJson';

export class InspectTranslation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoadingJson: false,
      loadError: null,
      playJson: null,
      query: '',
    };
  }

  componentDidMount() {
    this.fetchPlayJson();
  }

  componentWillUnmount() {
    this.unmounted = true;
  }

  async fetchPlayJson() {
    const { jsonUrl } = this.props;
    if (!jsonUrl) {
      this.setState({
        isLoadingJson: false,
        loadError: 'Play JSON URL is not available.',
        playJson: null,
      });
      return;
    }

    this.setState({ isLoadingJson: true, loadError: null, playJson: null });
    try {
      const response = await fetch(jsonUrl);
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }
      const playJson = await response.json();
      if (this.unmounted) {
        return;
      }
      this.setState({ playJson, isLoadingJson: false, loadError: null });
    } catch (err) {
      if (this.unmounted) {
        return;
      }
      console.error('Failed to load play JSON:', err);
      this.setState({
        isLoadingJson: false,
        playJson: null,
        loadError: 'Could not load play JSON.',
      });
    }
  }

  renderHits() {
    const { query, playJson, isLoadingJson, loadError } = this.state;
    if (isLoadingJson || loadError) {
      return null;
    }

    const trimmed = query.trim();
    if (!trimmed) {
      return null;
    }

    const hits = searchPlayJson(playJson, trimmed);
    if (hits.length === 0) {
      return <p className="text-muted mb-0">No matches.</p>;
    }

    return (
      <div style={{ maxHeight: '40vh', overflowY: 'auto' }}>
        <Table striped bordered size="sm" className="mb-0">
          <thead>
            <tr>
              <th>Branch</th>
              <th style={{ minWidth: '4.5rem', whiteSpace: 'nowrap' }}>Step</th>
              <th>Snippet</th>
            </tr>
          </thead>
          <tbody>
            {hits.map((hit, index) => (
              <tr key={`${hit.branchTitle}-${hit.stepIndex}-${index}`}>
                <td>{hit.branchTitle}</td>
                <td style={{ minWidth: '4.5rem', whiteSpace: 'nowrap' }}>{hit.stepIndex == null ? '—' : hit.stepIndex}</td>
                <td>{hit.snippet}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    );
  }

  render() {
    const {
      show, onHide, episodeTitle, chapter, language, revision, jsonUrl,
    } = this.props;
    const { isLoadingJson, loadError, query } = this.state;
    const languageLabel = language && language.code
      ? `(${language.code}) ${language.name}`
      : 'Unknown language';
    const chapterLabel = chapter == null || chapter === '' ? '—' : chapter;
    const revisionLabel = revision == null || revision === '' ? '—' : revision;

    return (
      <Modal show={show} onHide={onHide} size="lg">
        <Modal.Header closeButton>
          <Modal.Title style={{ whiteSpace: 'normal' }}>
            <div>{episodeTitle || 'Untitled episode'}</div>
            <div style={{ fontSize: '1rem', fontWeight: 400 }}>
              Chapter {chapterLabel}, Revision {revisionLabel}, {languageLabel}
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {jsonUrl ? (
            <p>
              <a href={jsonUrl} target="_blank" rel="noopener noreferrer">
                {jsonUrl}
              </a>
            </p>
          ) : (
            <p className="text-muted">Play JSON URL is not available.</p>
          )}
          {isLoadingJson && (
            <div className="text-center">
              <Spinner animation="border" />
            </div>
          )}
          {loadError && <p className="text-danger">{loadError}</p>}
          {!isLoadingJson && !loadError && (
            <Form.Group>
              <Form.Control
                type="text"
                placeholder="Search translated text"
                value={query}
                onChange={(e) => this.setState({ query: e.target.value })}
              />
            </Form.Group>
          )}
          {this.renderHits()}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
